export const sidebar = Object.freeze({
  today: 'TODAY',
  analysis: 'ANALYSIS',
  marketplace: 'MARKETPLACE',
});
